import { Controller, FieldValues, useController } from 'react-hook-form';

import TimeInput from '@/components/UI/TimeInput/TimeInput';

import { FieldError } from '../FieldError';
import { FieldProps } from '../types';

type RadioFieldProps<T extends FieldValues> = FieldProps<T> &
  Omit<React.ComponentPropsWithoutRef<typeof TimeInput>, keyof FieldProps<T>>;

export const TimeInputField = <T extends FieldValues>({
  control,
  name,
  required,
  rules,
  defaultValue,
  ...rest
}: RadioFieldProps<T>) => {
  const { fieldState } = useController<T>({
    name,
    control,
    rules: { required: required ? 'dit veld is verplicht' : undefined, ...rules },
    defaultValue,
  });
  return (
    <>
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({ field }) => <TimeInput {...field} {...rest} defaultValue={defaultValue} />}
      />
      <FieldError width='auto' error={fieldState.error} />
    </>
  );
};
